import React, { useContext } from "react";
import "./NewObjectModal.css";
import { LanguageContext } from "../context/LanguageContext";

const NewObjectModal = ({ isOpen, onClose, onContinue, onStartNew }) => {
  const { texts } = useContext(LanguageContext);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <h2>{texts.newObjectModal.title}</h2>

        <p>{texts.newObjectModal.description}</p>

        <div className="modal-buttons">
          <button className="modal-btn continue" onClick={onContinue}>
            {texts.newObjectModal.continue}
          </button>

          <button className="modal-btn new" onClick={onStartNew}>
            {texts.newObjectModal.startNew}
          </button>
        </div>

        <button className="modal-close" onClick={onClose}>
          ×
        </button>
      </div>
    </div>
  );
};

export default NewObjectModal;
